import React, { Component } from 'react';
import Recaptcha from 'react-recaptcha';
import Navbar from "../accueil/navbar/Navbar";
import Footer from '../accueil/footer/Footer';
import './Contact.css';
const SERVER_ADDRESS = process.env.REACT_APP_SERVER_ADDRESS;

class Contact extends Component {
    constructor() {
        super();
        this.state = {
            nom: "",
            prenom: "",
            telephone: "",
            email: "",
            description: "",
            isLoading: false,
            asLoading: false,
            isVerified: false
        }
        this.handlerChange = this.handlerChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        // captcha
        this.verifyCallback = this.verifyCallback.bind(this);
        this.RecaptchapLoader = this.RecaptchapLoader.bind(this);
        // fin captcha
    }
    handlerChange(event) {
        console.log(event.target.name);
        switch (event.target.name) {
            case 'Nom':
                this.setState({ nom: event.target.value });
                break;
            case 'Prenom':
                this.setState({ prenom: event.target.value });
                break;
            case 'telephone':
                this.setState({ telephone: event.target.value });
                break;
            case 'email':
                this.setState({ email: event.target.value });
                break;
            case 'description':
                this.setState({ description: event.target.value });
                break;
            default:
                break;
        }
    }
    snackbarClose = (event) => {
        this.setState({ snackbaropen: false })
    }
    handleSubmit(event) {
        event.preventDefault();
        if (this.state.isVerified) {
            this.setState({ isLoading: true })
            console.log(this.state)
            fetch(SERVER_ADDRESS + '/contact',
                {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(this.state),
                })
                .then(res => res.json())
                .then(
                    res => this.setState({ snackbarmessage: res.message }),
                )
                .then(
                    () => this.setState({ isLoading: false })
                )
                .then(
                    () => this.setState({ asLoading: true })
                )
        }
    }

    RecaptchapLoader() {
        console.log('capcha successfully loaded');
    }
    // handleSubscribe(){
    //     if (this.state.isVerified){
    //         alert('You have successfully subscribed!');
    //     }else{
    //         alert('Please verify that you are a humain!');
    //     }
    // }

    verifyCallback(response) {
        if (response) {
            this.setState({
                isVerified: true
            })
        }
    }
    render() {
        return (
            <div className="sticky-wrap">
                <Navbar />
                <div className="formulaire">
                    <form className="container align-containner-recrutement" onSubmit={this.handleSubmit}>
                        <div className="max-wi">

                            <div className="center-we-join"><strong>Nous contacter</strong></div>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">Nom</div>
                                    </div>
                                    <input type="text" name="Nom" placeholder="Nom" className="form-control" onChange={this.handlerChange} />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">Prénom</div>
                                    </div>
                                    <input type="text" name="Prenom" placeholder="Prenom" className="form-control" onChange={this.handlerChange} />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">Téléphone</div>
                                    </div>
                                    <input type="text" name="telephone" className="form-control" placeholder="numéro de téléphone" onChange={this.handlerChange} />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">Email</div>
                                    </div>
                                    <input type="email" name="email" className="form-control" placeholder="exemple@email.fr" onChange={this.handlerChange} />
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="input-group-text">Message</div>
                                <textarea name="description" className="form-control" id="exampleFormControlTextarea1" placeholder="Description de votre message" rows="3" onChange={this.handlerChange}></textarea>
                            </div>
                            <div className="captcha row justify-content-center">
                                <Recaptcha
                                    sitekey="6LcjTcQUAAAAAEa4n2XWWANTPERrWZQBO071ZJrA"
                                    render="explicit"
                                    hl="fr"
                                    onloadCallback={this.RecaptchapLoader}
                                    verifyCallback={this.verifyCallback}
                                />
                            </div>
                            {this.state.isLoading ?
                                <div className="d-block text-center pb-4" disabled>
                                    <button className="btn btn-primary" type="submit">Envoi de votre demande est contact en cours...</button>
                                </div> :
                                <div className="d-block text-center pb-4">

                                    <button className="btn-envoyer btn btn-primary" type="submit" >Envoyer</button>

                                </div>
                            }
                            {this.state.asLoading ?
                                <div className="alert alert-success" role="alert">
                                    {this.state.snackbarmessage}
                                </div>
                                :
                                ""
                            }
                        </div>
                    </form>
                </div>
                <div className="sticky-footer">
                    <Footer />
                </div>
            </div >
        )
    }
}

export default Contact;
